{
	"side-bar-panel-control": {
		"account": "Información de mi cuenta",
		"profile": "Mi perfil",
		"password": "Contraseña",
		"version": "Versión del sistema",
		"logout": "Cerrar sesión",
		"pref": "Preferencias",
		"config": "Config. de Webhook",
		
		"account-page": {
			"name": "Nombre completo", 
			"placeholder_name": "ej: Francisco Pérez",

			"email": "Correo de contacto",
			"placeholder_email": "ej: example@mail.com",

			"type": "Tipo de usuario",
			"placeholder_type": "ej: Administrador",

			"company": "Empresa",
			"placeholder_company": "ej: EXAMPLE COMPANY",

			"code_company": "Código de compañía",
			"code_propierty": "Código de propiedad",
			"name_propierty": "Nombre de la propiedad",

			"header-2": "Información de tu empresa",
			"ID": "ID de empleado",
			"header-3": "Código master",
			"code": "Tu código de hoy",
			"btn-generate": "Generar nuevo código",
			"btn": "Guardar cambios"
		},
		"password-page": {
			"txt-1": "Si quieres cambiar tu contraseña, ingresa la actual para iniciar el proceso.",

			"current": "Contraseña actual",
			"placeholder_current": "*****************",
			"new": "Nueva contraseña",
			"placeholder_new": "*****************",
			"confirm": "Confirmar contraseña",
			"placeholder_confirm": "*****************"
		},
		"preferences-page": {
			"dark-mode": "Modo oscuro",
			"light-mode": "Modo claro",
			"language": "Idioma",
			"es": "Español",
			"en": "Inglés"
		},
		"dialog": {
			"title": "Código de propiedad",
			"button": "Copiar código"
		},
		"notifications": {
			"updateAccount": {
				"title": "Información cambiada",
				"subtitle": "La información del usuario ha sido modificada."
			}
		}
	},
	"buttons": {
		"resetChanges": "Restablecer cambios",
		"saveInformation": "Guardar información",
		"saveChanges": "Guardar cambios",
		"add_client": "Agregar cliente",
		"addService": "Agregar servicio"
	},
"extend-package": {
	"column": "Extender",
	"action": "Extender",
	"actionAriaLabel": "Extender paquete por 3 días",
	"actionTooltip": "Extender paquete por 3 días",
	"title": "Extender paquete",
	"subtitle": "Confirma la acción antes de extender la vigencia del paquete.",
	"tracking": "Número de tracking",
	"resident": "Residente",
	"currentExpiration": "Expiración actual",
	"newExpiration": "Nueva expiración",
	"noticeTitle": "Extensión fija de 3 días",
	"notice": "El paquete volverá a estar disponible para recolección durante 3 días a partir de este momento.",
	"error": "No fue posible extender el paquete. Inténtalo nuevamente.",
	"buttons": {
		"cancel": "Cancelar",
		"confirm": "Extender 3 días"
	}
},
	"accountSettingsPage": {
		"title": "Mi cuenta",
		"switchContent": {
			"perfil": "Perfil",
			"notifycations": "Notificaciones",
			"preferences": "Preferencias"
		},
		"perfil": {
			"my-information": {
				"title": "Mi información",
				"subtitle": "Gracias a esta información podemos contactarte en caso de ser necesario, así como para procesos de devolución o aclaraciones.",
				"username": "Nombre de usuario",
				"placeholderUsername": "Nombre del titular",
				"idEmployee": "ID de empleado",
				"placeholderIDEmployee": "1324-5676",
				"email": "Correo electrónico",
				"placeholder": "nombre@ejemplo.com",
				"telephone": "Teléfono de contacto",
				"placeholderTelephone": "(81)1625-6549"
			},
			"password": {
				"title": "Contraseña",
				"subtitle": "Ingresa tu contraseña actual para poder crear una nueva.",
				"form": {
					"actual-password": "Contraseña actual",
					"placeholder_actual": "*****************",
					"new-password": "Tu nueva contraseña",
					"placeholder_newPassword": "Ej: 1Qazxsw2*-",
					"boxValidation": {
						"title": "Para proteger tu cuenta, asegúrate de que tu contraseña tenga:",
						"validation1": "Una letra mayúscula",
						"validation2": "Un número",
						"validation3": "Un carácter especial",
						"validation4": "Un mínimo de 8 caracteres"
					},
					"confirmPassword": "Confirmar tu contraseña",
					"placeholder_confirmPassword": "*****************",
					"btnUpdatePassword": "Actualizar mi contraseña"
				}
			}
		},
		"notifications": {
			"dashboard-notifications": {
				"title": "Notificaciones en dashboard",
				"subtitle": "Selecciona qué tipo de notificaciones quieres recibir. Las notificaciones del sistema no se pueden desactivar.",
				"selects": {
					"title-order": "Órdenes",
					"subtitle-order": "Órdenes recibidas, en ruta de entrega, en locker, recolectadas, expiradas, etc.",
					"title-fulfillment": "Fulfillment",
					"subtitle-fulfillment": "Productos recibidos en almacén, reingresos, bajas y unidades nulas en stock.",
					"title-tickets": "Tickets de pago",
					"subtitle-tickets": "Tickets nuevos, fechas de vencimiento, pagos aprobados o rechazados."
				}
			},
			"dashboard-email": {
				"title": "Notificaciones por correo electrónico",
				"subtitle": "Estas notificaciones se envían cada vez que algo importante pasa con tu cuenta. Selecciona qué tipo de correos quieres recibir.",
				"selects": {
					"title-order": "Órdenes",
					"subtitle-order": "Órdenes recibidas, en ruta de entrega, en locker, recolectadas, expiradas, etc.",
					"title-fulfillment": "Fulfillment",
					"subtitle-fulfillment": "Productos recibidos en almacén, reingresos, bajas y unidades nulas en stock.",
					"title-tickets": "Tickets de pago",
					"subtitle-tickets": "Tickets nuevos, fechas de vencimiento, pagos aprobados o rechazados.",
					"title-surveys": "Encuestas",
					"subtitle-surveys": "Estas encuestas sirven para que podamos mejorar y ofrecerte una mejor experiencia."
				}
			},
			"passwordChanged": {
				"title": "Contraseña cambiada",
				"subtitle": "La contraseña ha sido cambiada.",
				"subtitleApp": "La contraseña ha sido cambiada."
			},
			"buttons": {}
		},
		"preferences": {
			"appearance": {
				"title": "Apariencia",
				"subtitle": "Configura la interfaz a tu gusto; selecciona el color principal o el modo en el que se encuentra.",
				"color-primary": {
					"title": "Color principal",
					"subtitle": "Este color se verá en botones o bordes."
				},
				"mode": {
					"title": "Modo",
					"light": "Claro",
					"dark": "Oscuro"
				}
			},
			"language": {
				"title": "Idioma",
				"subtitle": "Configura la apariencia de tu aplicación a tu gusto; cambia su color principal o el modo, ya sea claro u oscuro.",
				"lang": {
					"es": "Español",
					"en": "Inglés"
				}
			}
		}
	},
	"loginPage": {
		"title": "Bienvenido",
		"subtitle": "Por favor, ingresa la siguiente información para continuar.",
		"form": {
			"email": "Correo electrónico",
			"placeholder_email": "nombre@ejemplo.com",
			"password": "Contraseña",
			"placeholder_password": "**************",
			"checkbox": "Recordar mi información",
			"forgetPassword": "Olvidé mi contraseña",
			"btnLogin": "Iniciar sesión",
			"footer": "¿Eres nuevo en fulfillment?",
			"footerLink": "Nosotros te ayudamos"
		},
		"alert": {
			"code-1202": {
				"msgTitle": "Hubo un error",
				"msgSubtitle": "Nombre de usuario inválido o contraseña incorrecta"
			}
		}
	},
	"createNewPassword": {
		"forgotPasswordForm": {
			"title": "Olvidé mi contraseña",
			"subtitle": "No te preocupes, le puede pasar a cualquiera. Escribe el correo asociado a tu cuenta y te diremos como puedes recuperarla.",
			"email": "Correo electrónico",
			"recoverPassword": "Recuperar mi contraseña",
			"buttonThrowback": "Volver a la pantalla principal"
		},
		"title": "Crea una nueva contraseña",
		"subtitle": "Completa los siguientes campos y recupera tu cuenta para que puedas seguir enviando tus productos.",
		"form": {
			"labelNewPassword": "Tu nueva contraseña",
			"boxValidation": {
				"title": "Para proteger tu cuenta, asegúrate que tu contraseña tiene:",
				"validation1": "Una mayúscula",
				"validation2": "Un número",
				"validation3": "Un carácter especial",
				"validation4": "Que tenga mínimo 8 caracteres"
			},
			"confirmPassword": "Confirmar tu contraseña",
			"btnUpdatePassword": "Actualizar mi contraseña"
		},
		"passwordChanged": {
			"title": "¡Todo listo!",
			"subtitle": "Sabíamos que estarías de vuelta. Has recuperado tu cuenta y ahora ya puedes seguir administrando tu red logistica con nosotros.",
			"subtitleApp": "Sabíamos que estarías de vuelta. Has recuperado tu cuenta. Ahora cierra esta pestaña e inicia sesion en la aplicacion de Package Hub"
		},
		"passwordNotChanged": {
			"title": "¡Oh hubo un error!",
			"subtitle": "Lamentamos lo que ha pasado, podrias rehacer el proceso para el cambio de contraseña"
		},
		"oneStepMore": {
			"title": "Solo un paso más...",
			"subtitle-1": "Si el correo",
			"subtitle-2": "está asociado a una cuenta recibirás un correo con los siguientes pasos. Asegúrate de revisar tu carpeta de correos no deseados o spam.",
			"paragraph-1": "¿No estas seguro del correo que ingresaste?",
			"paragraph-2": "Intenta con uno diferente."
		},
		"buttons": {
			"throwback-login": "Ir a la pantalla principal",
			"updatePassword": "Actualizar mi contraseña",
			"sendEmail": "Reenviar correo",
			"returnBackLogin": "Volver a la pantalla principal",
			"closeWindow": "Cerrar"
		},
		"notifications": {
			"emailSending": {
				"title": "Se ha reenviado correo",
				"subtitle": "Comprueba tu carpeta de correo no deseado o spam. Si sigues sin recibirlo, comprueba que tu correo electrónico está bien escrito."
			}
		}
	},
	"sidebarComponent": {
		"settings": {
			"title": "Ajustes",
			"languages": {
				"title": "Idioma",
				"es": "Español",
				"en": "Inglés"
			},
			"appearance": {
				"title": "Apariencia",
				"light": "Claro",
				"dark": "Oscuro"
			}
		}
	},
	"lockerPage": {
		"title": "Lockers",
		"buttons": {
			"add_locker": "Agregar nuevo locker"
		},
		"cards": {
			"cardsOrders": {
				"card-1": {
					"title": "Órdenes entregadas",
					"tooltip": "Cantidad de entregas totales desde el inicio de uso del sistema.",
					"footer": "Información no disponible"
				},
				"card-2": {
					"title": "Órdenes recolectadas",
					"tooltip": "Cantidad de recolecciones totales desde el inicio de uso del sistema.",
					"footer": "vs mes pasado"
				},
				"card-3": {
					"title": "Órdenes en locker",
					"tooltip": "Cantidad de paquetes que actualmente se encuentran en todos nuestros lockers.",
					"footer": "vs mes pasado"
				}
			},
			"mapCard": {
				"title": "Ubicaciones"
			}
		},
		"location": "Ubicación",
		"input-search": "Buscar...",
		"filters": "Filtros",
		"export": "Exportar",
		"table": {
			"alias": "Alias\ndel locker",
			"location": "Ubicación",
			"name_propierty": "Nombre de\npropiedad",
			"totalDeliveries": "Entregas\ntotales",
			"doors": "Puertas",
			"doorsAvailable": "Puertas\ndisponibles",
			"failedDoor": "Puertas\ndañadas",
			"status": "Estatus"
		},
		"statusLocker": {
			"1": "Activo",
			"2": "Inactivo"
		}
	},
	"lockerDetailPage": {
		"breadcrumb": {},
		"contentSwitcher": {
			"resumen": "Resumen",
			"actividad": "Actividad",
			"sync": "Sincronización",
			"cam": "Cámaras"
		},
		"cards": {
			"cardsLocker": {
				"card-1": {
					"title": "Puertas pequeñas",
					"tooltip": "Medidas: 8 cm de alto, 37.5 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				},
				"card-2": {
					"title": "Puertas medianas",
					"tooltip": "Medidas: 18 cm de alto, 37.5 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				},
				"card-3": {
					"title": "Puertas grandes",
					"tooltip": "Medidas: 28 cm de alto, 37.5 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				},
				"card-4": {
					"title": "XL grandes",
					"tooltip": "Medidas: 47.5 cm de alto, 37.5 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				},
				"card-5": {
					"title": "Puertas XXL grandes",
					"tooltip": "Medidas: 926 cm de alto, 546 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				},
				"card-6": {
					"title": "Puertas XXXL grandes",
					"tooltip": "Medidas: 926 cm de alto, 1092 cm de ancho, 55 cm de profundidad",
					"footer": "Disponibles"
				}
			},
			"cardsOrders": {
				"card-1": {
					"title": "Entregas totales (todo el tiempo)",
					"tooltip": "Tooltip de entregas totales (todo el tiempo)",
					"footer": "vs mes pasado"
				},
				"card-2": {
					"title": "Retornos totales (todo el tiempo)",
					"tooltip": "Tooltip de retornos totales (todo el tiempo)",
					"footer": "vs mes pasado"
				},
				"card-3": {
					"title": "Entregas totales (día actual)",
					"tooltip": "Tooltip de entregas totales (día actual)",
					"footer": "vs mes pasado"
				},
				"card-4": {
					"title": "Retornos totales (día actual)",
					"tooltip": "Tooltip de retornos totales (día actual)",
					"footer": "vs mes pasado"
				}
			},
			"cardMap": {
				"averageCollected": "Promedio de recolección",
				"useOfLocker": "Uso del locker",
				"registerHistoric": "Registro histórico",
				"title": "Ubicación",
				"collected": "Recolectado",
				"delivered": "Entregados",
				"expired": "Expirado"
			}
		},
		"table": {
			"contentSwitcher": {
				"todas": "Todas",
				"proceso": "En proceso",
				"expiradas": "Expiradas",
				"agendadas": "Agendadas",
				"completadas": "Completadas",
				"canceladas": "Canceladas",
				"unsassigned": "Unassigned",
				"fails":"Fallas"
			},
			"activity": {
				"eventId": "ID del\nevento",
				"event": "Evento",
				"name_propierty": "Nombre de\npropiedad",
				"dateEvent": "Fecha de evento",
				"description": "Descripción"
			},
			"general": {
				"tracking_number": "Número de\ntracking",
				"order_number": "Número de\norden",
				"name_propierty": "Nombre de\npropiedad",
				"name_service": "Tipo de\nservicio",
				"locker_name": "Locker",
				"email": "Email",
				"door_number": "Puerta",
				"status": "Estatus",
				"date_in_locker": "Fecha de\nrecibido",
				"date_collected": "Fecha de\nretirado",
				"date_expired": "Fecha de expiración",
				"generate_qr": "Generar QR"
			},
			"expired": {
				"tracking_number": "Número de\nseguimiento",
				"name_propierty": "Nombre de\npropiedad",
				"name_service": "Tipo de servicio",
				"email": "Email",
				"door_number": "Puerta",
				"status": "Estatus",
				"date_in_locker": "Fecha de recibido",
				"date_expired": "Fecha de expiración"
			},
			"completed": {
				"tracking_number": "Número de\nseguimiento",
				"name_propierty": "Nombre de\npropiedad",
				"name_service": "Tipo de\nservicio",
				"locker_name": "Locker",
				"email": "Email",
				"door_number": "Puerta",
				"status": "Estatus",
				"date_in_locker": "Fecha de recibido",
				"date_collected": "Fecha de retirado",
				"rate": "Calificación"
			},
			"schedule": {
				"package": "Paquete",
				"name_propierty": "Nombre de\npropiedad",
				"name_service": "Tipo de\nservicio",
				"otp": "OTP",
				"email": "Email",
				"door_number": "Puerta",
				"size_compartment": "Tamaño",
				"status": "Estatus",
				"register_date": "Fecha de registro"
			},
			"canceled": {
				"tracking_number": "Número de\nseguimiento",
				"name_propierty": "Nombre de\npropiedad",
				"name_service": "Tipo de\nservicio",
				"nameEmploye": "Empleado que\ncanceló",
				"door_number": "Puerta",
				"status": "Estatus",
				"date_collected": "Fecha de retirado",
				"date_cancel": "Fecha de cancelado",
				"locker_name": "Locker"
			},
			"fails":{
				"code_service":"Código de servicio",
				"locker_name":"Locker",
				"name_consumer":"Nombre\ndel consumidor",
				"email":"Correo",
				"door_number":"Puerta",
				"position":"Compartimento",
				"registration_date":"Fecha\nde registro",
				"update_date":"Fecha\nde actualización"
			}
		},
		"estatus": {
			"RECOLECTADO": "Recolectado",
			"RETURN": "Devuelto",
			"ENTREGADO": "Entregado",
			"SCHEDULED": "Agendado",
			"PENDIENTE": "Pendiente",
			"EXPIRED": "Expirado",
			"EXTENDED": "Extendido",
			"LOCKER": "En Locker",
			"CANCELED": "Cancelado",
			"CANCELED_LOCKER": "Cancelado en Locker",
			"CANCELED_PICKED": "Cancelado retirado",
			"PASSWORD_EXPIRADO": "Password expirado",
			"ACTIVE": "Activo",
			"DESACTIVE": "Desactivado",
			"PackageCollected": "Paquete recolectado",
			"PackageInLocker": "Paquete en locker",
			"PackageExpired": "Paquete expirado",
			"Warehouse": "En almacén",
			"ScheduledDoor": "Puerta programada",
			"OpenDoor": "Puerta abierta",
			"CloseDoor": "Puerta cerrada",
			"FailDoor": "Fallo en puerta",
			"BusyDoor": "Puerta ocupada",
			"loginSuccess": "Éxito en login",
			"loginError": "Intento login",
			"useMasterCode": "Uso master code",
			"logout": "Logout",
      "IN_TRANSIT": "En tránsito",
      "PENDING_VALIDATE": "Pendiente de validar",
      "PENDING_PAYMENT": "Pendiente de pago",
      "IN_PROGRESS": "En proceso",
      "PROPERTY": "En propiedad"
		},
		"comparments": {
			"disponible": "Disponible",
			"agendado": "Agendado",
			"expirado": "Expirado",
			"abierto": "Abierto",
			"ocupado": "Ocupado",
			"defectuoso": "Defectuoso",
			"unassigned": "Sin asignar"
		},
		"camera": {
			"table": {
				"cam_name": "Nombre de la cámara",
				"type": "Tipo",
				"format": "Formato",
				"function": "Función",
				"fps": "FPS",
				"status": "Estado"
			},
			"records": {
				"table": {
					"id_record": "ID de grabación",
					"date_record": "Fecha y hora",
					"duration": "Duración",
					"size": "Tamaño",
					"actions": "Acciones"
				}
			}
		},
		"synchronized": {
			"title": "Sincronización",
			"buttons": {
				"sync": "Sincronizar"
			},
			"table": {
				"id_locker_sync_pending": "Sincronización de ID locker pendiente",
				"id_type_event": "Tipo de evento",
				"event_name": "Nombre del evento",
				"registration_date": "Fecha de registro",
				"attempt_count": "Número de intentos",
				"last_description": "Última descripción",
				"processed_at": "Procesado",
				"is_processed": "Está procesado",
				"processed": "Procesado"
			}
		}
	},
	"usersPage": {
		"title": "Usuarios",
		"table": {
			"admin": {
				"first_name": "Nombre",
				"surname": "Apellidos",
				"user_type": "Tipo\nde usuario",
				"email": "Email\ndel usuario",
				"active_days": "Días\nactivo",
				"registration_date": "Fecha de registro",
				"id_status": "Estatus del\nusuario",
				"actions": "Acción"
			},
			"worker": {
				"access_code": "Código\nde acceso",
				"first_name": "Nombre\ndel operador",
				"surname": "Apellido\ndel operador",
				"email": "Email",
				"id_status": "Estatus\ndel operador",
				"is_connected": "Está\nconectado",
				"device": "Dispositivo",
				"last_activity": "Última actividad",
				"geographical_location": "Ubicación\ngeográfica",
				"battery_consumption": "Consumo\nde batería",
				"actions": "Acciones"
			}
		},
		"contentSwitcher": {
			"Admin": "Admin",
			"HouseAccount": "House Account",
			"Worker": "Worker",

			"Active": "Activo",
			"Desactive": "Desactivado"
		},
		"buttons": {
			"createUser": "Crear usuario"
		},
		"overloads": {
			"noRows": {
				"title": "No hay nada aquí...",
				"subtitle": "Parece que no pudimos encontrar ningún elemento que coincida con tu búsqueda."
			},
			"loading": {
				"title": "Cargando contenido..."
			}
		},
		"dialogs": {
			"dialogChangeStatusUser": {
				"headerTitle": "¿Estás seguro de que quieres desactivar a este usuario?",
				"subHeaderTitle": "Al desactivar un usuario, este perderá el acceso al dashboard y no podrá entregar paquetes a ningún locker. Puedes volver a activar a este usuario en cualquier momento.",
				"buttons": {
					"cancel": "Cancelar",
					"desactivate": "Sí, quiero desactivarlo"
				}
			},
			"dialogEditUser": {
				"title": "Editar usuario",
				"editUser": {
					"title": "Agregar usuario",
					"fieldNameCompany": "Nombre de la empresa",
					"fieldIdEmployee": "ID de empleado",
					"fieldTypeEmployee": "Tipo de usuario",
					"fieldNameEmployee": "Nombre completo",

					"fieldFirstNameEmployee": "Nombre",
					"fieldSurNameEmployee": "Apellidos",

					"fieldEmail": "Email",
					"fieldPassword": "Contraseña",
					"fieldConfirmPassword": "Confirma la contraseña",
					"btnGeneratePassword": "Generar contraseña",
					"btnCancel": "Cancelar",
					"btnContinue": "Continuar",
					"errorFieldRequired": "Campo requerido",
					"errorFieldPassword": "La contraseña no es igual",
					"errorFieldEmail": "Asegúrate de ingresar un email válido",
					"errorFieldId": "Campo requerido. Debe contener entre 6 y 8 caracteres.",
					"passwordInfo": "La contraseña para el acceso será enviada al correo que proporcionaste.",
					"passwordInfoCarrier": "La contraseña para el acceso será enviada al correo: "
				}
			},
			"dialogAddUser": {
				"title": "Agregar usuario",
				"fields": {
					"user_type": "Tipo de usuario",
					"first_name": "Nombre",
					"surname": "Apellidos",
					"email": "Email",
					"id_propierty": "Propiedades",
					"id_line_services": "Línea de servicio",

					"placeholder_nameEmployee": "ex: Juan Jiménez Rodríguez",
					"placeholder_email": "ex: example@mail.com",
					"passwordInfo": "La contraseña para el acceso será enviada al correo que proporcionaste."
				},
				"placeholder": {
					"user_type": "Seleccione el rol de usuario",
					"first_name": "Ej: Juan",
					"surname": "Ej: Ramones Terán",
					"email": "Ej: email@hotmail.com",
					"id_propierty": "Seleccione la propiedad del usuario",
					"id_line_services": "Seleccione la línea de servicio"
				},
				"buttons": {
					"cancel": "Cancelar",
					"saveUser": "Guardar usuario"
				}
			},
			"dialogEditUserWorker": {
				"title": "Editar usuario",
				"fields": {
					"user_type": "Tipo de usuario",
					"first_name": "Nombre",
					"surname": "Apellidos",
					"email": "Email",
					"id_propierty": "Propiedades",

					"placeholder_nameEmployee": "ex: Juan Jiménez Rodríguez",
					"placeholder_email": "ex: example@mail.com",
					"passwordInfo": "La contraseña para el acceso será enviada al correo que proporcionaste."
				},
				"placeholder": {
					"user_type": "Seleccione el rol de usuario",
					"first_name": "Ej: Juan",
					"surname": "Ej: Ramones Terán",
					"email": "Ej: email@hotmail.com",
					"id_propierty": "Seleccione la propiedad del usuario"
				},
				"buttons": {
					"cancel": "Cancelar",
					"saveUser": "Guardar usuario"
				}
			},
			"worker": {
				"delete-worker": {
					"title": "Eliminar operador",
					"subtitle": "Aquí podrás eliminar al operador de tu propiedad, asegúrate de que sea el operador correcto el que eliminarás.",
					"buttons": {
						"cancel": "Cancelar",
						"delete": "Eliminar cliente"
					}
				},
				"sign-out-worker": {
					"title": "Cerrar sesión al operador",
					"subtitle": "Aquí podrás cerrar la sesión al operador de tu propiedad, asegúrate de que sea el operador correcto al que le cerrarás la cuenta.",
					"buttons": {
						"cancel": "Cancelar",
						"sign-out": "Cerrar sesión"
					}
				},
				"refresh-code-access": {
					"title": "Código de acceso",
					"buttons": {
						"generate": "Generar código"
					}
				}
			}
		},
		"cards": {
			"card-1": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			},
			"card-2": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			},
			"card-3": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			},
			"card-4": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			},
			"card-5": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			},
			"card-6": {
				"title": "KPI usuario",
				"tooltip": "Tooltip de KPI usuarios",
				"footer": "Información no disponible"
			}
		},
		"alerts": {
			"userCanceled": {
				"title": "Has cancelado la creación del usuario",
				"subtitle": "Intenta crear el usuario nuevamente"
			},
			"userDeleted": {
				"title": "Has eliminado al usuario",
				"subtitle": "Se ha eliminado el usuario correctamente"
			},
			"userRepeated": {
				"title": "Usuario duplicado",
				"subtitle": "No se insertó porque el usuario ya existe."
			},
			"userCreated": {
				"title": "El usuario ha sido creado",
				"subtitle": "Se mostrará el usuario creado en la tabla y ahora podrá ingresar al dashboard"
			},
			"userNotCreated": {
				"title": "El usuario no ha sido creado",
				"subtitle": "Hubo un error al momento de crear al usuario, favor de intentarlo nuevamente"
			},
			"userModified": {
				"title": "El usuario ha sido modificado",
				"subtitle": "Los datos del usuario han sido modificados con éxito"
			},
			"userNotModified": {
				"title": "El usuario no ha sido modificado",
				"subtitle": "Los datos del usuario no han sido modificados."
			},
			"userDesactivate": {
				"title": "La cuenta del usuario ha sido desactivada",
				"subtitle": "La cuenta del usuario seleccionado ha sido desactivada, no podrá ingresar al dashboard"
			},
			"userActivate": {
				"title": "La cuenta del usuario ha sido activada",
				"subtitle": "La cuenta del usuario seleccionado ha sido activada, ahora podrá ingresar al dashboard"
			}
		}
	},
	"clientsPage": {
		"title": "Clientes",
		"detailClients": "Detalle del cliente",
		"cards": {
			"card-1": {
				"title": "Clientes totales",
				"tooltip": "Cantidad total de usuarios desde el inicio del uso del sistema.",
				"footer": "Información no disponible"
			},
			"card-2": {
				"title": "Clientes únicos",
				"tooltip": "Clientes que recogen órdenes solo una vez.",
				"footer": "Información no disponible"
			},
			"card-3": {
				"title": "Clientes recurrentes",
				"tooltip": "Clientes que recogen órdenes más de dos veces.",
				"footer": "Información no disponible"
			},
			"metrics": {
				"title": "Métricas del cliente",
				"unique_clients": "Únicos",
				"recurring_clients": "Recurrentes"
			}
		},
		"dialogs": {
			"delete-clients": {
				"title": "Eliminar cliente",
				"subtitle": "Aquí podrás eliminar clientes de tu propiedad, asegúrate de que sea el cliente correcto el que eliminarás.",
				"buttons": {
					"cancel": "Cancelar",
					"delete": "Eliminar cliente"
				}
			},
			"change-status-client": {
				"title": "Cambiar estatus del cliente",
				"subtitle": "Aquí puedes",
				"2": "activar",
				"1": "desactivar",
				"subtitle-1": "el acceso del cliente",
				"subtitle-2": "en tu propiedad.",
				"buttons": {
					"cancel": "Cancelar",
					"confirm": "Confirmar"
				}
			},
			"change-status-service": {
				"title": "Cambiar estatus del servicio",
				"subtitle": "Aquí puedes",
				"2": "activar",
				"1": "desactivar",
				"subtitle-1": "el estatus de",
				"buttons": {
					"cancel": "Cancelar",
					"confirm": "Confirmar"
				}
			}
		},
		"metric": {
			"title": "Volumen total de envíos",
			"store": "Tienda",
			"locker": "Locker",
			"days": {
				"monday": "Lunes",
				"tuesday": "Martes",
				"wednesday": "Miércoles",
				"thursday": "Jueves",
				"friday": "Viernes",
				"saturday": "Sábado",
				"sunday": "Domingo"
			}
		},
		"overloads": {
			"noRows": {
				"title": "No hay nada aquí...",
				"subtitle": "Parece que no pudimos encontrar ningún elemento que coincida con tu búsqueda."
			},
			"loading": {
				"title": "Cargando contenido..."
			}
		},
		"table": {
			"user_name": "Nombre del usuario",
			"has_pending_payment_access":"¿Pago\npendiente?",
			"user_unit_number": "Número\nde unidad",
			"status_user": "Estado\ndel usuario",
			"user_information": "Información\ndel usuario",
			"monthly_usage": "Uso",
			"total_usage": "Uso total",
			"holidays":"Vacaciones",

			"client_name": "Destinatario",
			"email": "Correo\nelectrónico",
			"viviID": "VIVI ID",
			"telephone": "Teléfono",
			"reference_code": "Código de\nreferencia",
			"name_propierty": "Nombre de\npropiedad",
			"paid_packages": "Paquetes\nrecogidos",
			"register_date": "Fecha de registro",
			"status": "Estatus\ndel cliente",
			"status_service": "Estatus\ndel servicio",

			"actions": "Acción",
			"pendingPayment":"Pendiente",
			"noPendingPayment":"Suscrito"
		},
		"notifications": {
			"userNotDeleted": {
				"title": "No se ha eliminado el usuario",
				"subtitle": "Hubo un error al momento de eliminar al usuario"
			},
			"userDeleted": {
				"title": "Se ha eliminado el usuario",
				"subtitle": "El usuario ha sido eliminado de la base de datos con éxito"
			},
			"userAdded": {
				"title": "Usuario agregado",
				"subtitle": "El usuario ha sido agregado exitosamente. La tabla se actualizará instantáneamente."
			},
			"userCanceled": {
				"title": "Has cancelado la creación de un nuevo cliente",
				"subtitle": "Se ha cerrado el modal de crear nuevo cliente."
			},
			"userEdited": {
				"title": "Usuario editado",
				"subtitle": "El usuario ha sido editado exitosamente. La tabla se actualizará instantáneamente."
			},
			"userNotModified": {
				"title": "El usuario no ha sido modificado",
				"subtitle": "Los datos del usuario no han sido modificados."
			},
			"userNotAdded": {
				"title": "Usuario no agregado",
				"subtitle": "El usuario no pudo ser agregado. Hubo un error."
			},
			"statusChanged": {
				"title": "El estatus ha cambiado",
				"subtitle": "El estatus ha sido cambiado. La tabla será actualizada instantáneamente."
			},
			"statusNotChanged": {
				"title": "El estatus no ha sido cambiado",
				"subtitle": "No se logró modificar el estatus, el usuario tiene paquetes asignados."
			},
			"userAsignedToNewUnit": {
				"title": "El cliente ha sido asignado",
				"subtitle": "Ahora el cliente tendra asignado la nueva unidad en la propiedad"
			}
		}
	},
	"addClientDialog": {
		"headerContainer": {
			"title": "Agregar cliente",
			"subtitle": "Por favor, ingresa la siguiente información para dar de alta al cliente"
		},
		"bodyContainer": {
			"dialog": {
				"fields": {
					"first_name": "Nombre",
					"surname": "Apellidos",
					"email": "Email",
					"telephone": "Teléfono",
					"id_propierty": "Propiedad",
					"reference_code": "Referencia",
					"sobriquet": "Tipo de ubicación",
					"id_unit": "Unidad",
					"id_type_consumer": "Tipo de consumidor"
				},
				"placeholder": {
					"first_name": "Ex: Juan",
					"surname": "Ex: Ramones Terán",
					"email": "Ex: email@hotmail.com",
					"telephone": "Ex: 8117616451",
					"id_propierty": "Seleccione una propiedad de la lista",
					"sobriquet": "Seleccione un tipo de propiedad",
					"reference_code": "Número de apartamento, casa o empleado",
					"id_unit": "Seleccione la unidad del cliente",
					"id_type_consumer": "Seleccione el tipo de consumidor"
				}
			}
		}
	},
	"timePicker": {
		"hour": "Hora",
		"minute": "Minuto",
		"buttons": {
			"erase": "Borrar",
			"cancel": "Cancelar",
			"accept": "Aceptar"
		}
	},
	"overviewPage": {
		"title": "Bienvenido, ",
		"export": "Exportar",
		"heatMap": {
			"title": "Horario de mayor uso",
			"categories": {
				"d1": "Lunes",
				"d2": "Martes",
				"d3": "Miércoles",
				"d4": "Jueves",
				"d5": "Viernes",
				"d6": "Sábado",
				"d7": "Domingo"
			}
		},
		"barChart": {
			"title": "Top 5 de lockers más utilizados",
			"legends": {
				"use_of_locker": "Uso del locker"
			}
		},
		"barChartComparative": {
			"title": "Total de paquetes expirados",
			"categories": {
				"d1": "Lunes",
				"d2": "Martes",
				"d3": "Miércoles",
				"d4": "Jueves",
				"d5": "Viernes",
				"d6": "Sábado",
				"d7": "Domingo"
			},
			"legends": {
				"deliver_package": "Paquetes entregados",
				"undeliver_package": "Paquetes no entregados"
			}
		}
	},
	"ordersPage": {
		"title": "Órdenes",
		"cards": {
			"cardsOrders": {
				"card-1": {
					"title": "Uso total",
					"footer": "Información no disponible",
					"tooltip": "Conteo de todas las órdenes entregadas, recolectadas y devueltas desde el inicio del uso del sistema."
				},
				"card-2": {
					"title": "Uso medio por hora",
					"footer": "Información no disponible",
					"tooltip": "Promedio de uso total por horas activas del locker. Se calcula en base a las órdenes entregadas y recolectadas por hora."
				},
				"card-3": {
					"title": "Horario de mayor uso",
					"footer": "Información no disponible",
					"tooltip": "Hora donde se entregan y recolectan más órdenes."
				}
			}
		},
		"metrics": {
			"title": "Métricas de órdenes",
			"delivered": "Entregados",
			"collected": "Recolectado",
			"expired": "Expirado"
		},
		"overloads": {
			"loading": {
				"title": "Loading content..."
			},
			"general": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás todas las ordenes y el estatus en el que se encuentran."
				}
			},
			"inLocker": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás las ordenes en proceso e información sobre ellas."
				}
			},
			"expired": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás las ordenes expiradas e información sobre ellas."
				}
			},
			"scheduled": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás las ordenes agendadas e información sobre ellas."
				}
			},
			"completed": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás las ordenes completadas e información sobre ellas."
				}
			},
			"canceled": {
				"noRows": {
					"title": "No hay nada aquí...",
					"subtitle": "En esta tabla encontrarás las ordenes canceladas e información sobre ellas."
				}
			}
		},
		"tables": {
			"general": {
				"storeName": "Nombre de\nTienda",
				"storeAlias": "Alias de\nTienda",
				"storeCode": "Código de\nTienda",
				"address": "Dirección",
				"latitude": "Latitud",
				"longitude": "Longitud",
				"state": "Estado",
				"city": "Ciudad",
				"referenceCode": "CR",
				"openingHours": "Horario de atención",
				"opening_time": "Hora de\napertura",
				"closing_time": "Hora de\nclausura",
				"packageManaged": "Paquetes \nmanejados",
				"accion": "Acción"
			}
		},
		"filters": {
			"title": "Filtros",
			"status_title": "Estatus",
			"status": {
				"return": "Devueltos",
				"completed": "Completadas",
				"in_locker": "En locker",
				"expired": "Expirado",
				"canceled": "Canceladas",
				"cancelInLocker": "Cancelado en Locker",
				"cancelWithdrawn": "Cancelado retirado"
			},
			"rates": {
				"0": "Sin calificación",
				"1": "Deficiente",
				"2": "Malo",
				"3": "Regular",
				"4": "Bueno",
				"5": "Excelente"
			},
			"rate_title": "Calificación"
		},
		"estatus": {
			"RECOLECTADO": "Recolectado",
			"RETURN": "Devuelto",
			"ENTREGADO": "Entregado",
			"SCHEDULED": "Agendado",
			"PENDIENTE": "Pendiente",
			"EXPIRED": "Expirado",
			"EXTENDED": "Extendido",
			"PROPERTY": "En propiedad",
			"LOCKER": "En Locker",
			"CANCELED": "Cancelado",
			"CANCELED_LOCKER": "Cancelado En Locker",
			"CANCELED_PICKED": "Cancelado Retirado",
			"PASSWORD_EXPIRADO": "Password Expirado",
			"ACTIVE": "Activo",
			"DESACTIVE": "Desactivado",
			"PackageCollected": "Paquete Colectado",
			"PackageInLocker": "Paquete en Locker",
			"PackageExpired": "Paquete Expirado",
			"Warehouse": "En Almacén",
			"ScheduledDoor": "Puerta Programada",
			"OpenDoor": "Puerta Abierta",
			"CloseDoor": "Puerta Cerrada",
			"FailDoor": "Fallo en Puerta",
			"BusyDoor": "Puerta Ocupada",
			"loginSuccess": "Éxito en Login",
			"loginError": "Intento log-in",
			"useMasterCode": "Uso Master Code",
			"logout": "Log-out",
      "IN_TRANSIT": "En tránsito",
      "PENDING_VALIDATE": "Pendiente de validar",
      "PENDING_PAYMENT": "Pendiente de pago",
      "IN_PROGRESS": "En proceso"
		},
		"notifications": {
			"assignedNewAddresee": {
				"title": "Se ha asignado el paquete al nuevo usuario",
				"subtitle": "La fecha de expiración ha sido actualizada y se enviará correo al nuevo usuario"
			}
		}
	},
	"dialogToUploadFile": {
		"title": "Importar clientes",
		"subtitle": "Revisa que los datos de los clientes que quieras ingresar sean correctos. Esto no es una acción definitiva; puedes editar los valores de las tiendas manualmente y de manera individual una vez las hayas dado de alta.",
		"table": {
			"name": "Nombre",
			"lastname": "Apellido",
			"email": "Correo",
			"telephone": "Teléfono",
			"location": "Tipo\nde ubicación",
			"reference": "Referencia",
			"unity": "Unidad",
			"isAccepted": "Estatus"
		},
		"buttons": {
			"addUsers": "Agregar clientes",
			"cancel": "Cancelar"
		},
		"error": {
			"title": "Hubo un error",
			"subtitle": "Los datos no han sido registrados. En breve verás un detalle del por qué no han sido ingresados los clientes.",
			"buttons": {
				"close": "Cerrar"
			}
		}
	},
	"menu": {
		"orders": "Órdenes",
		"appearance": "Apariencia",
		"lang": "Idioma",
		"light": "Claro",
		"dark": "Oscuro",
		"integrations": "Integraciones",
		"version": "Versión del sistema",
		"profile": "Perfil",
		"account": "Mi cuenta",
		"routes": "Rutas",
		"request": "Solicitudes",
		"inventory": "Inventario por cliente",
		"locker_tolocker": "Locker to locker",
		"add_orders": "Ingresar órdenes",
		"fullfillment": "Fulfillment",
		"incidents": "Incidencias",
		"partners": "Socios PUDO",
		"transporter": "Transportista",
		"subscriptions": "Subscripciones",
		"units": "Unidades",
		"tickets": "Tickets"
	},
	"settings": {
		"profile": "Mi perfil",
		"integrations": "Integraciones",
		"webhook": "Configuración Webhook",
		"version": "Versión del sistema",
		"logout": "Cerrar sesión"
	},
	"page403": {
		"title": "Error 403",
		"subtitle": "Acceso denegado",
		"paragraph": "Parece que no tiene permiso para ver esta página. Por favor, intente acceder de nuevo y, si el error persiste, no dude en contactarnos. Estamos para ayudarle a resolverlo."
	},
	"page404": {
		"title": "Error 404",
		"subtitle": "Página no disponible",
		"paragraph": "Sentimos no haber podido encontrar lo que buscaba. Intente actualizar la página o regresar a la página de inicio."
	},
	"page500": {
		"title": "Error 500",
		"subtitle": "Página no disponible",
		"paragraph": "Parece que hemos encontrado un problema, pero no te preocupes. Intenta actualizar la página o regresar a la página de inicio."
	},
	"page503": {
		"title": "Error 503",
		"subtitle": "Este servicio no está disponible",
		"paragraph": "El servicio al que intentas acceder no está disponible en este momento. Intenta actualizar la página o regresar a la página de inicio."
	},
	"navbar": {
		"overview": "Resumen",
		"locker": "Locker",
		"worker": "Operadores",
		"orders": "Órdenes",
		"return": "Devoluciones",
		"carrier": "Transportistas",
		"users": "Usuarios",
		"clients": "Clientes",
		"welcome": "Bienvenido de nuevo",
		"company": "Compañía",
		"profile": "Perfil",
		"stores": "Tiendas",
		"panel": "Panel de control",
		"account": "Cuenta",
		"oxxo_to_oxxo": "OXXO a OXXO",
		"active_routes": "Rutas activas",
		"lang": "Idioma",
		"appearance": "Apariencia",
		"integrations": "Integraciones",
		"version": "Versión del sistema",
		"webhook": "Configuración de Webhook",
		"myaccount": "Mi cuenta",
		"es": "Español",
		"en": "Inglés",
		"dark": "Modo oscuro",
		"light": "Modo claro",
		"log-package": "Auditoría de paquetes",
		"property": "Propiedades"
	},
	"month": {
		"Ene": "Ene",
		"Feb": "Feb",
		"Mar": "Mar",
		"Abr": "Abr",
		"May": "May",
		"Jun": "Jun",
		"Jul": "Jul",
		"Ago": "Ago",
		"Sep": "Sep",
		"Oct": "Oct",
		"Nov": "Nov",
		"Dic": "Dic"
	},
	"uploadDocument": {
		"buttonLabel": "Subir archivo de clientes",
		"popupTitle": "Importa tus datos de clientes",
		"popupSubtitle": "Puedes subir un archivo con los datos de tus clientes. Si aún no tienes un archivo con el formato correcto, puedes descargar una plantilla",
		"popupLink": "haciendo clic aquí.",
		"fileUploader": {
			"link": "Haz clic aquí",
			"clickHere": " para abrir tu explorador de archivos y seleccionar el archivo a importar.",
			"fileSizeLimit": "El archivo que subas no puede ser mayor a 10MB."
		},
		"fileUpload": {
			"fileName": "{{this.file.name}}",
			"fileSize": "{{ (this.file.size / 1024 / 1024).toFixed(2) }} MB",
			"progress": "{{this.progress}}%"
		},
		"errors": {
			"fileSizeOver": "Parece que el archivo que intentas subir pesa más de 10MB. Revísalo e inténtalo de nuevo.",
			"invalidFileType": "El tipo de archivo no es válido. Sólo se permiten archivos Excel (extensiones csv o xls).",
			"invalidHeaders": "El archivo no contiene los encabezados requeridos: Nombre, Apellido, Email, Teléfono."
		},
		"alert": {
			"text": "Usuarios creados",
			"subtitle": "Los usuarios han sido creados"
		}
	},
	"notifications": {
		"title": "Notificaciones",
		"checkItAll": "Marcar todo como leído",
		"button": "Ver actividad",
		"switchContent": {
			"orders": "Órdenes",
			"users": "Usuarios",
			"all": "Todos"
		},
		"buttons": {
			"close": "Cerrar",
			"notifyActivity": "Actividad de notificaciones"
		},
		"empty": {
			"title": "No hay nada aquí",
			"subtitle": "Aquí encontrarás tus notificaciones sobre paquetes o problemas operativos."
		},
		"items": {
			"packet": "El paquete",
			"user": "El usuario",
			"statusTopic": {
				"4": "ha iniciado sesión en",
				"5": "ha cerrado sesión en",
				"6": "ha encontrado un error en",
				"7": "ha intentado iniciar sesión en",
				"8": "ha sido recogido en",
				"9": "ha sido entregado en",
				"10": "ha usado el código maestro en",
				"11": "ha sido expirado en",
				"14": "ha sido devuelto a",
				"25": "ha sido ingresado en",
				"26": "ha sido asignado a",
				"27": "está en tránsito desde el CEDIS de origen",
				"28": "se encuentra en el CEDIS de origen",
				"29": "está en tránsito hacia el CEDIS de destino",
				"30": "se encuentra en el CEDIS de destino",
				"31": "está en tránsito hacia",
				"32": "está siendo inspeccionado en el CEDIS",
				"33": "ha sido inspeccionado",
				"34": "ha sido confiscado",
				"35": "se encuentra en",
				"36": "ha sido entregado",
				"37": "ha expirado en",
				"38": "ha sido recogido de",
				"39": "ha sido recogido por el cliente",
				"40": "está en proceso de devolución al origen",
				"41": "ha sido devuelto al cliente original",
				"42": "ha entrado en proceso legal"
			},
			"ago": "Hace",
			"minutes": "minutos",
			"hours": "horas",
			"days": "días",
			"months": "meses",
			"years": "años"
		}
	},
	"systemVersionPage": {
		"title": "Versión del sistema",
		"table": {
			"version": "Versión",
			"date": "Fecha",
			"json": "Ver JSON"
		}
	},
	"orderDetail": {
		"title-orderDetail": "Detalles de la orden",
		"subtitle-informationGeneral": "Información general",
		"timeline": "Línea del tiempo",
		"informationGeneral": {
			"trackingNumber": "Número de tracking",
			"otpValidation": "OTP",
			"orderNumber": "Número de orden",
			"emailClient": "Email del cliente",
			"phoneClient": "Teléfono del cliente",
			"nameEmployee": "Nombre del empleado",
			"numberOfDoor": "Número de puerta",
			"orderStatus": "Estatus de la orden",
			"typeDelivery": "Tipo de entrega",
			"inLocker": "Recibido en el locker",
			"scheduledDate": "Fecha agendada",
			"expirationDate": "Fecha de expiración",
			"cancelDate": "Fecha de cancelación",
			"removedLocker": "Retirado del locker",
			"deliverDate": "Fecha de entrega",
			"qualificationClient": "Calificación del cliente"
		},
		"subtitle-accessQR": "QR de acceso",
		"qrAccess": {
			"btnDownload": "Descargar"
		},
		"subtitleReminder": "Recordatorios",
		"Reminder": {
			"addReminder": "Agregar recordatorio",
			"noReminder": "Los recordatorios que agregues se verán aquí."
		},
		"subtitleEvidence": "Evidencia de entrega",
		"Evidence": {
			"signEvidence": "Firma",
			"recollectionEvidence": "Foto de recolección"
		},
		"eraseOrder": "Borrar orden"
	},
	"estatus": {
		"RECOLECTADO": "Recolectado",
		"RETURN": "Devuelto",
		"ENTREGADO": "Entregado",
		"SCHEDULED": "Agendado",
		"PENDIENTE": "Pendiente",
		"EXPIRED": "Expirado",
		"EXTENDED": "Extendido",
		"LOCKER": "En locker",
		"CANCELED": "Cancelado",
		"CANCELED_LOCKER": "Cancelado en locker",
		"CANCELED_PICKED": "Cancelado y retirado",
		"PASSWORD_EXPIRADO": "Contraseña expirada",
		"ACTIVE": "Activo",
		"DESACTIVE": "Desactivado",
		"PackageCollected": "Paquete colectado",
		"PackageInLocker": "Paquete en locker",
		"PackageExpired": "Paquete expirado",
		"Warehouse": "En almacén",
		"ScheduledDoor": "Puerta programada",
		"OpenDoor": "Puerta abierta",
		"CloseDoor": "Puerta cerrada",
		"FailDoor": "Fallo en puerta",
		"BusyDoor": "Puerta ocupada",
		"loginSuccess": "Éxito en inicio de sesión",
		"loginError": "Intento de inicio de sesión",
		"useMasterCode": "Uso de código maestro",
		"logout": "Cerrar sesión"
	},
	"companyPage": {
		"title": "Compañía",
		"add_company": "Agregar compañía",
		"cards": {
			"card-1": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-2": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-3": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-4": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			}
		},
		"buttons": {
			"add_company": "Agregar compañía",
			"save": "Guardar"
		},
		"forms": {
			"company": {
				"email": "Email",
				"placeholder_email": "ejemplo@mail.com",
				"password": "Contraseña",
				"placeholder_password": "**************",
				"company_name": "Nombre de compañía",
				"placeholder_company_name": "Ejemplo compañía",
				"trfc": "RFC",
				"placeholder_trfc": "ABCD010199AA1",
				"phone_number": "Número telefónico",
				"placeholder_phone_number": "8111234567",
				"acronym": "Acrónimo",
				"placeholder_acronym": "EJEM",
				"copyright": "Copyright",
				"placeholder_copyright": "Ejemplo SA de CV",
				"address": "Dirección",
				"placeholder_address": "Selecciona una ubicación del mapa",
				"latitud": "Latitud",
				"placeholder_latitud": "25.726532603330796",
				"selectLocation": "Selecciona la ubicación de la compañía",
				"longitud": "Longitud",
				"placeholder_longitud": "-100.4173968080368",
				"city": "Ciudad",
				"placeholder_city": "Seleccione una ciudad",
				"state": "Estado",
				"placeholder_state": "Seleccione un estado"
			},
			"branchs": {
				"email": "Email",
				"placeholder_email": "ejemplo@mail.com",
				"password": "Contraseña",
				"placeholder_password": "**************",
				"name_propierty": "Nombre de propiedad",
				"placeholder_name_propierty": "Nombre de la propiedad",
				"description": "Descripción",
				"placeholder_description": "Descripción de la propiedad",
				"address": "Dirección",
				"placeholder_address": "Selecciona una ubicación del mapa",
				"city": "Ciudad",
				"placeholder_city": "Seleccione una ciudad",
				"state": "Estado",
				"placeholder_state": "Seleccione un estado",
				"latitude": "Latitud",
				"placeholder_latitude": "25.726532603330796",
				"longitude": "Longitud",
				"placeholder_longitud": "-100.4173968080368",
				"selectLocation": "Selecciona la ubicación de la propiedad"
			}
		},
		"table": {
			"company_name": "Nombre de\ncompañía",
			"address": "Dirección",
			"trfc": "RFC",
			"company_type": "Tipo de compañía",
			"latitude": "Latitud",
			"longitude": "Longitud",
			"accion": "Acción",
			"edit": "Editar",
			"acronym": "Acrónimo",
			"copyright": "Copyright",
			"phone_number": "Número\ntelefónico",
			"email": "Email",
			"status": "Estatus",
			"registration_date": "Fecha de registro"
		},
		"branchTable": {
			"name_propierty": "Nombre de propiedad",
			"address": "Dirección",
			"line_service": "Tipo de servicio",
			"description": "Descripción",
			"city": "Ciudad",
			"state": "Estado",
			"by_contract": "¿Por contrato?",
			"latitud": "Latitud",
			"longitud": "Longitud"
		},
		"pages": {
			"packages": {
				"contentSwitcher": {
					"todas": "Todas",
					"proceso": "En proceso",
					"expiradas": "Expiradas",
					"agendadas": "Agendadas",
					"completadas": "Completadas",
					"canceladas": "Canceladas"
				},
				"table": {
					"fields": {
						"tracking_number": "Orden",
						"locker_name": "Locker",
						"name_service": "Servicio",
						"email": "Correo",
						"door_number": "Puerta",
						"status_name": "Estatus",
						"package_delivery_date": "Fecha de\nrecibido",
						"package_pickup_date": "Fecha de\nrecogida",
						"code_service": "Código de servicio",
						"otp": "OTP",
						"registration_date": "Fecha de registro",
						"compartment_name": "Nombre del\ncompartimento",
						"update_date": "Fecha de actualización"
					}
				}
			}
		}
	},
	"companyDetailPage": {
		"breadcrumb": {
			"superUser": {
				"company": "Compañía"
			},
			"admin": {
				"property": "Propiedades"
			}
		},
		"cards": {
			"card-1": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-2": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-3": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-4": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"bigCard": {
				"title": "Propiedades"
			}
		},
		"tableProperty": {
			"name_propierty": "Nombre de\npropiedad",
			"address": "Dirección",
			"description_place": "Descripción",
			"code_propierty": "Código\nde propiedad",
			"registration_date": "Fecha de registro",
			"update_date": "Fecha de actualización",
			"actions": "Acción",
			"log_subscription": "Historial de suscripciones"
		},
		"buttons": {
			"createProperty": "Crear propiedad"
		}
	},
	"propertyDetailPage": {
		"cards": {
			"card-1": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-2": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-3": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			},
			"card-4": {
				"title": "KPI pendiente",
				"footer": "Información no disponible",
				"tooltip": "Tooltip de KPI pendiente."
			}
		},
		"tableServices": {
			"name_propierty_unit": "Nombre del servicio",
			"line_service_name": "Tipo de\nservicio",
			"city": "Ciudad",
			"state_name": "Estado",
			"country_name": "País",
			"address": "Dirección",
			"allow_signature": "Permitir firma",
			"enable_carrier_passcode": "Permitir código\nde carrier",
			"enable_lsa_webcam_photo": "Permitir foto\nde webcam LSA"
		},
		"buttons": {
			"createProperty": "Crear propiedad"
		}
	},
	"addLineServicePage": {
		"company": "Compañía",
		"addService": "Agregar servicio",
		"addProperty": "Agregar propiedad",
		"subtitle": "Aquí podrás agregar los servicios para tu propiedad. Por favor, llena todos los campos requeridos.",
		"forms": {
			"name_propierty_unit": "Nombre de propiedad",
			"placeholder_name_propierty_unit": "Ejemplo de propiedad",

			"city": "Ciudad",
			"placeholder_city": "Seleccione una ciudad",
			"state": "Estado",
			"placeholder_state": "Seleccione un estado",

			"address": "Dirección",
			"placeholder_address": "Selecciona una ubicación en el mapa",

			"latitude": "Latitud",
			"placeholder_latitude": "25.726532603330796",

			"longitude": "Longitud",
			"placeholder_longitude": "-100.4173968080368",

			"id_line_service": "Tipo de servicio",
			"placeholder_id_line_service": "Seleccione un servicio",

			"locker": "Locker",
			"placeholder_locker": "Seleccione un locker"
		}
	},
	"alerts": {
		"code-1202": {
			"msgTitle": "Hubo un error",
			"msgSubtitle": "Nombre de usuario inválido o contraseña incorrecta"
		},
		"code-1500": {
			"msgTitle": "Hubo un error",
			"msgSubtitle": "Existen datos duplicados"
		},
		"code-1501": {
			"msgTitle": "Hubo un error",
			"msgSubtitle": "Error inesperado en la respuesta del servidor"
		},
		"code-": {
			"msgTitle": "Hubo un error",
			"msgSubtitle": "Error inesperado en la respuesta del servidor"
		},
		"code-1502": {
			"msgTitle": "Hubo un error",
			"msgSubtitle": "Error al guardar la empresa y las sucursales"
		}
	},
	"notificationDetails": {
		"title": "Notificaciones",
		"table": {
			"sending_number": "Número de\nenvío",
			"description": "Descripción",
			"locker_name": "Locker",
			"order_number": "Número de\norden",
			"id_topic_audit": "Estatus",
			"registration_date": "Fecha de registro"
		},
		"status": {
			"status_1": "Actualizado",
			"status_2": "Eliminado",
			"status_3": "Registrado",
			"status_4": "Inicio de sesión",
			"status_5": "Cierre de sesión",
			"status_6": "Error",
			"status_7": "Inicio de sesión en locker",
			"status_8": "Recogida de paquete",
			"status_9": "Entrega de paquete",
			"status_10": "Uso de código maestro",
			"status_11": "Paquete caducado",
			"status_12": "Programado",
			"status_13": "Enviado a webhook",
			"status_14": "Reembolso",
			"status_15": "Puerta abierta",
			"status_16": "Puerta cerrada",
			"status_17": "Falla en puerta",
			"status_18": "Puerta ocupada",
			"status_19": "Error de inicio de sesión",
			"status_20": "Contraseña de empleado caducada",
			"status_21": "Error usando código maestro empleado",
			"status_22": "Acceso a la aplicación de pruebas",
			"status_23": "Error de acceso a la aplicación de pruebas",
			"status_24": "Actualización de paquetes programados",
			"status_25": "En el locker",
			"status_26": "Asignado",
			"status_27": "En tránsito - origen CEDIS",
			"status_28": "En CEDIS de origen",
			"status_29": "En tránsito - destino CEDIS",
			"status_30": "En CEDIS de destino",
			"status_31": "En tránsito - destino locker",
			"status_32": "En revisión",
			"status_33": "Revisado",
			"status_34": "Arrestado",
			"status_35": "En locker de destino",
			"status_36": "Entregado",
			"status_37": "Caducado",
			"status_38": "Recogido",
			"status_39": "Recogido por el cliente",
			"status_40": "En proceso de retorno al origen",
			"status_41": "Devuelto",
			"status_42": "Proceso legal",
			"status_43": "Intento fallido de visitar un locker",
			"status_44": "Intento de inicio de sesión en el sistema manual",
			"status_45": "Intento de inicio de sesión en el sistema con insignia",
			"status_46": "Inicio de sesión exitoso",
			"status_47": "Inicio del backend del locker",
			"status_48": "ERROR: Placa de circuito impreso no instalada",
			"status_49": "ERROR: Módulo no configurado",
			"status_50": "ERROR: Fallo al configurar el puerto USB de la placa de circuito impreso",
			"status_51": "Reiniciando el backend del locker",
			"status_52": "Registro de intentos para validar seguimiento",
			"status_53": "Captura de pantalla realizada",
			"status_54": "Iniciar el backend del locker en modo virtual",
			"status_55": "Consulta de OXXOWAY",
			"status_56": "Pago de OXXOWAY",
			"status_57": "Reversa de OXXOWAY",
			"status_58": "Error de OXXOWAY",
			"status_59": "Servicio no utilizado",
			"status_60": "El servicio de pago caducó"
		}
	},
	"versionPage": {
		"title": "Versión del sistema",
		"table": {
			"version": "Versión",
			"launchingDate": "Fecha de lanzamiento",
			"description": "Descripción",
			"action": "Acción"
		}
	},
	"change-person-to-deliver": {
		"title": "Actualizar destinatario",
		"subtitle": "Se cometió un error al asignar este paquete. No te preocupes, busca al destinatario correcto en la siguiente lista y actualiza el registro. Al hacerlo, se enviarán las notificaciones correspondientes al destinatario seleccionado.",
		"placeholder-input": "Ingresa el nombre o VIVI-ID del cliente",
		"buttons": {
			"cancel": "Cancelar",
			"updateClient": "Actualizar destinatario"
		}
	},
	"transporterPage": {
		"title": "Transportista",
		"buttons": {
			"add_carrier": "Agregar transportista"
		},
		"cards": {
			"card-1": {
				"title": "Total de transportistas registrados",
				"footer": "Información no disponible",
				"tooltip": "Cantidad total de transportistas en el sistema."
			},
			"card-2": {
				"title": "Total de transportistas activos",
				"footer": "Información no disponible",
				"tooltip": "Transportistas con actividad reciente o habilitados en el sistema."
			},
			"card-3": {
				"title": "Total de transportistas inactivos",
				"footer": "Información no disponible",
				"tooltip": "Transportistas que no han realizado entregas en un período determinado."
			}
		},
		"dialog": {
			"dialogEditCarrier": {
				"title": "Edición de transportista",
				"subtitle": "Permite la edición de transportistas desde el dashboard",
				"fields": {
					"full_name": "Nombre completo",
					"alias": "Alias del transportista",
					"logo": "Logo",
					"type_carrier": "Tipo de transportista",
					"placeholder": {
						"full_name": "Ingrese el nombre completo del transportista",
						"alias": "Ingrese un alias para el transportista",
						"type_carrier": "Seleccione un tipo de transportista"
					}
				},
				"buttons": {
					"save": "Guardar",
					"cancel": "Cancelar",
					"resetChanges": "Restablecer cambios"
				}
			},
			"dialogAddCarrier": {
				"title": "Registro de transportistas",
				"subtitle": "Permite el registro manual de transportistas desde el dashboard",
				"fields": {
					"full_name": "Nombre completo",
					"alias": "Alias del transportista",
					"logo": "Logo",
					"type_carrier": "Tipo de transportista",
					"placeholder": {
						"full_name": "Ingrese el nombre completo del transportista",
						"alias": "Ingrese un alias para el transportista",
						"type_carrier": "Seleccione un tipo de transportista",
						"logo_click": "Da clic aquí",
						"logo_span": "para abrir tu explorador de archivos."
					}
				},
				"buttons": {
					"save": "Guardar",
					"cancel": "Cancelar",
					"resetChanges": "Restablecer cambios"
				}
			},
			"dialogDeleteCarrier": {
				"title": "Eliminar transportista",
				"subtitle": "Aquí podrás eliminar transportistas. Asegúrate de seleccionar el transportista correcto antes de eliminarlo.",
				"buttons": {
					"cancel": "Cancelar",
					"delete": "Eliminar transportista"
				},
				"messages": {
					"correctlyRemoved": {
						"text1": "El transportista",
						"text2": "ha sido correctamente eliminado",
						"subtitle": "La tabla se recargará al cerrar el proceso"
					},
					"notCorrectlyRemoved": {
						"text1": "El transportista",
						"text2": "no ha sido eliminado",
						"subtitle": "Por favor, inténtalo más tarde"
					}
				}
			},
			"dialogChangeStatusCarrier": {
				"headerTitle": "¿Estás seguro de que quieres desactivar a este transportista?",
				"subHeaderTitle": "Al desactivar al transportista, este perderá el acceso y no podrá entregar paquetes a ningún locker. Puedes volver a activarlo en cualquier momento.",
				"buttons": {
					"cancel": "Cancelar",
					"deactivate": "Sí, quiero desactivarlo",
					"activate": "Sí, quiero activarlo"
				}
			}
		},
		"table": {
			"courier_name": "Nombre completo",
			"alias_courier": "Alias del transportista",
			"logo_courier_small": "Logo",
			"name_courier_type": "Tipo de transportista",
			"code_to_deliver": "Código de acceso",
			"actions": "Acciones",
			"id_status": "Estatus del transportista"
		},
		"charts": {
			"totalCarrierPerType": {
				"title": "Total de transportistas por tipo"
			},
			"busiestCarrier": {
				"title": "Transportista con mayor actividad"
			},
			"transporterWithLessActivity": {
				"title": "Transportista con menor actividad"
			},
			"averageOrdersDeliveredPerCarrier": {
				"title": "Promedio de órdenes entregadas por transportista"
			}
		}
	},
	"transporterDetailPage": {
		"breadcrumb": {
			"lastPage": "Transportista"
		},
		"buttons": {
			"createReport": "Generar reporte"
		},
		"cards": {
			"card-1": {
				"title": "Total de paquetes entregados",
				"footer": "Información no disponible",
				"tooltip": "Cantidad total de paquetes registrados en el sistema."
			},
			"card-2": {
				"title": "Total de paquetes disponibles para retiro",
				"footer": "Información no disponible",
				"tooltip": "Paquetes aún no retirados por inquilinos o empleados."
			},
			"card-3": {
				"title": "Paquetes retirados",
				"footer": "Información no disponible",
				"tooltip": "Paquetes que han sido recogidos exitosamente."
			},
			"card-4": {
				"title": "Paquetes vencidos",
				"footer": "Información no disponible",
				"tooltip": "Cantidad de paquetes no retirados en el tiempo límite."
			},
			"card-5": {
				"title": "Tiempo promedio de permanencia de paquetes",
				"footer": "Información no disponible",
				"tooltip": "Tiempo que tarda un paquete en ser retirado desde su ingreso."
			},
			"card-6": {
				"title": "Tiempo promedio de registro de paquetes",
				"footer": "Información no disponible",
				"tooltip": "Tiempo que tarda un transportista en completar el registro de un paquete."
			},
			"card-7": {
				"title": "Promedio de paquetes entregados por visita",
				"footer": "Información no disponible",
				"tooltip": "Cantidad promedio de paquetes que un transportista deja en cada visita."
			}
		},
		"charts": {
			"quantityOfDeliverByMounth": {
				"title": "Cantidad de entregas por mes",
				"months": {
					"Jan": "Ene",
					"Feb": "Feb",
					"Mar": "Mar",
					"Apr": "Abr",
					"May": "May",
					"Jun": "Jun",
					"Jul": "Jul",
					"Aug": "Ago",
					"Sep": "Sep",
					"Oct": "Oct",
					"Nov": "Nov",
					"Dec": "Dic"
				}
			},
			"totalPackageDelivered": {
				"title": "Total de paquetes entregados",
				"locker": "Entregados en el locker",
				"operator": "Entregados al operador"
			},
			"rateOfDeliveredVsOverduePackages": {
				"title": "Tasa de paquetes entregados vs vencidos",
				"deliver": "Entregado",
				"expired": "Expirado"
			}
		},
		"table": {
			"tracking_number": "Número de\nseguimiento",
			"full_name_recipient": "Destinatario",
			"full_name": "Nombre",
			"description_income_option": "Razón",
			"status_package": "Estatus",
			"registration_date": "Fecha de\nregistro",
			"package_pickup_date": "Fecha de\nrecogida",
			"locker_name": "Locker",
			"name_propierty": "Nombre de\npropiedad",
			"name_service": "Tipo de\nservicio",
			"email": "Email",
			"door_number": "Puerta",
			"package_delivery_date": "Fecha de\nrecibido",
			"date_collected": "Fecha de\nretirado",
			"registration_date_expired": "Fecha de\nexpiración",
			"update_date": "Fecha de cancelado",
			"size": "Tamaño",
			"otp": "OTP",
			"rate": "Calificación",
			"name_employee": "Usuario que canceló"
		},
		"overlays": {
			"noContentGeneral": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás todas las órdenes y el estatus en el que se encuentran."
			},
			"noContentProcess": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás las órdenes en proceso e información sobre ellas."
			},
			"noContentExpired": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás las órdenes expiradas e información sobre ellas."
			},
			"noContentScheduled": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás las órdenes agendadas e información sobre ellas."
			},
			"noContentCompleted": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás las órdenes completadas e información sobre ellas."
			},
			"noContentCanceled": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás las órdenes canceladas e información sobre ellas."
			},
			"noContentActivity": {
				"title": "No hay nada por aquí...",
				"subtitle": "En esta tabla encontrarás la actividad del locker e información sobre ella."
			},
			"noData": {
				"title": "Sin resultados",
				"subtitle": "Parece que no pudimos encontrar ningún elemento que coincida con tu búsqueda."
			}
		}
	},
	"workerPage": {
		"title": "Worker",
		"cards": {
			"card-1": {
				"title": "Paquetes recibidos",
				"footer": "Información no disponible",
				"tooltip": "Cantidad de paquetes que ha recibido el Worker."
			},
			"card-2": {
				"title": "Paquetes recolectados",
				"footer": "Información no disponible",
				"tooltip": "Cantidad de paquetes que el Worker ha entregado al inquilino."
			},
			"card-3": {
				"title": "Paquetes almacenados por el Worker",
				"footer": "Información no disponible",
				"tooltip": "Cantidad de paquetes que actualmente están almacenados por el Worker."
			},
			"card-4": {
				"title": "Paquetes expirados",
				"footer": "Información no disponible",
				"tooltip": "Cantidad de paquetes que han expirado bajo la gestión del Worker."
			}
		},
		"table": {
			"order_number": "Número de\norden",
			"worker": "Worker",
			"recipient": "Destinatario",
			"status": "Estatus",
			"package_delivery_date": "Fecha de\nrecibido",
			"date_collected": "Fecha de\nretirado",
			"delivery_reason": "Motivo de entrega",
			"property": "Propiedad",
			"carrier": "Transportista"
		}
	},
	"common": {
		"no_data_available": "No hay datos disponibles"
	},
	"StatusPackage": {
		"status_1": "Activo",
		"status_2": "Inactivo",
		"status_3": "Bloqueado",
		"status_4": "Abierto",
		"status_5": "Cerrado",
		"status_6": "Fallando",
		"status_7": "Reparado",
		"status_8": "Pendiente",
		"status_9": "Procesado",
		"status_10": "Anulado",
		"status_11": "Pendiente",
		"status_12": "Pendiente por pago",
		"status_13": "Pagado",
		"status_14": "Disponible",
		"status_15": "En proceso",
		"status_16": "Entregado",
		"status_17": "Asignado",
		"status_18": "Utilizado",
		"status_19": "Bloqueado",
		"status_20": "Eliminado",
		"status_21": "Enviado",
		"status_22": "Recordatorio",
		"status_23": "Fallo al enviar",
		"status_24": "Ocupado",
		"status_25": "Pendiente por pago",
		"status_26": "Pagado",
		"status_27": "Instalado",
		"status_28": "En stock",
		"status_29": "Asignado",
		"status_30": "Anulado",
		"status_31": "Devuelto",
		"status_32": "Vencido",
		"status_33": "Recolectado",
		"status_34": "Password expirado",
		"status_35": "Agendado",
		"status_36": "Agendado",
		"status_37": "En proceso",
		"status_38": "No aprobada",
		"status_39": "Pendiente de pago",
		"status_40": "Finalizado",
		"status_41": "Cancelado",
		"status_42": "Pendiente de aprobacion",
		"status_43": "Aprobado",
		"status_44": "Para actualizar",
		"status_45": "Cancelado por pago",
		"status_46": "Cancelado sin utilizar",
		"status_47": "En locker",
		"status_48": "Asignado",
		"status_49": "En transito Cedis origen",
		"status_50": "En Cedis origen",
		"status_51": "En transito Cedis destino",
		"status_52": "En Cedis destino",
		"status_53": "En transito a locker destino",
		"status_54": "En revisión",
		"status_55": "Devolucion requerida",
		"status_56": "Confiscado",
		"status_57": "En locker destino",
		"status_58": "Entregado",
		"status_59": "Expirado",
		"status_60": "Recogido caducado",
		"status_61": "Recogido en Cedis destino",
		"status_62": "Retorno a origen",
		"status_63": "Recogido en Cedis origen",
		"status_64": "Proceso legal",
		"status_65": "Bloqueado",
		"status_66": "Asignado expirado",
		"status_67": "En Cedis esperando recoleccion",
		"status_68": "Retornado",
		"status_69": "En propiedad",
		"status_70": "Disponible en propiedad",
		"status_72": "Procesando pago"
	},
	"order_detail": {
		"breadcrumb": {
			"orders": "Órdenes",
			"carriers": "Transportistas",
			"workers": "Workers",
			"detail_locker": "Detalle del locker"
		},
		"buttons": {
			"sendEmail": "Reenviar notificaciones"
		},
		"notifications": {
			"both": {
				"title": "Notificaciones enviadas",
				"subtitle": "El usuario recibirá notificaciones por correo electrónico y en la aplicación."
			},
			"email": {
				"title": "Notificaciones enviadas",
				"subtitle": "El usuario recibirá notificaciones por correo electrónico."
			},
			"push": {
				"title": "Notificaciones enviadas",
				"subtitle": "El usuario recibirá notificaciones en la aplicación."
			}
		},
		"historic": {
			"title": "Histórico de la orden",
			"timeline": {
				"SCHEDULED": "Nueva orden agendada",
				"CANCELED_UNUSED": "Orden cancelada sin uso",
				"IN_LOCKER": "Orden disponible para recogida",
				"IN_PROPIERTY": "Orden disponible para recogida",
				"EXPIRED": "La orden ha expirado",
				"PICKUPPACKAGE": "Orden completada"
			},
			"deliver_process": {
				"title": "Proceso de entrega",
				"scheduled_date": "Agendado en locker",
				"deliver_date": "Entregado en locker",
				"collect_date": "Recogido del locker",
				"qualification": "Calificación",
				"not_available": "No disponible",
				"evidence_collected": "Evidencia de recolección",
				"evidence_pickup": "Evidencia de entrega",
				"not_evidence": "La evidencia de entrega se mostrará aquí",
				"not_evidence_collected": "La evidencia de recolección se mostrará aquí",
				"not_evidence_pickup": "La evidencia de entrega se mostrará aquí"
			}
		},
		"property": {
			"title": "Propiedad",
			"open_google_maps": "Abrir en Google Maps",
			"address": "Dirección",
			"description": "Descripción",
			"name_property": "Nombre de la propiedad",
			"opening_hours": "Horario de atención",
			"weekdays": "Lunes a viernes",
			"weekends": "Sábado y domingo"
		},
		"lockerDetail": {
			"title": "Detalle del locker",
			"open_google_maps": "Abrir en Google Maps",
			"destiny_locker": "Nombre del locker",
			"door_assigned": "Puerta asignada",
			"maximum_measures": "Tamaño máximo permitido",
			"sending_type": "Tipo de servicio",
			"address_locker": "Dirección del locker"
		},
		"clientDetail": {
			"title": "Detalle del cliente",
			"client_name": "Nombre del cliente",
			"client_phone": "Teléfono del cliente",
			"notifications_email": "Notificaciones por email",
			"notifications_push": "Notificaciones push",
			"client_email": "Correo electrónico del cliente"
		},
		"carrierDetail": {
			"title": "Detalle del transportista",
			"carrier_name": "Nombre del transportista",
			"carrier_code_deliver": "Código de entrega",
			"signature_required": "Firma requerida",
			"logo": "Logo",
			"yes": "Sí",
			"no": "No"
		},
		"order_detail": {
			"title": "Detalle de la orden",
			"order_number": "Número de orden",
			"tracking": "Número de seguimiento",
			"register_date": "Fecha de registro",
			"otp": "OTP",
			"collected_date": "Fecha de recolección",
			"expiration_date": "Fecha de expiración"
		},
		"notify-details": {
			"title": "Notificaciones",
			"id_notification_package": "ID de notificación",
			"type_notification": "Tipo de notificación",
			"send_date": "Fecha de envío",
			"status": "Estatus",
			"message_type": "Tipo de notificación"
		}
	},
	"timeline": {
		"title": {
			"SCHEDULE": "Orden agendada",
			"ASSIGNED": "Orden asignada",
			"IN_LOCKER": "Orden en locker",
			"EXPIRED": "Orden expirada",
			"ACTUALIZAR": "Orden actualizada",
			"COLLECTED": "Orden entregada",
			"PICKUPPACKAGE": "Orden recogida",
			"RETURNED": "Orden devuelta",
			"REFUND": "Orden devuelta",
			"DELIVERYPACKAGE": "Orden entregada",
			"CANCELED_UNUSED": "Orden cancelada sin usar",
			"IN_PROPERTY": "En propiedad"
		},
		"description": {
			"SCHEDULE": "Se ha agendado la orden",
			"ASSIGNED": "La orden ha sido asignada",
			"IN_LOCKER": "La orden ha sido ingresada al locker",
			"ACTUALIZAR": "La orden ha sido actualizada",
			"EXPIRED": "Oh no, la orden ha expirado",
			"COLLECTED": "Por fin la orden fue entregada, ¡buen trabajo!",
			"PICKUPPACKAGE": "La orden ha sido recogida",
			"RETURNED": "La orden ha sido devuelta",
			"REFUND": "La orden ha sido devuelta",
			"DELIVERYPACKAGE": "La orden ha sido entregada",
			"CANCELED_UNUSED": "La orden ha sido cancelada sin usar"
		}
	},
	"unitsPage": {
		"title": "Unidades",
		"breadcrumb": {
			"company": "Compañía",
			"property": "Propiedad",
			"residents": "Residentes",
			"floor_units": "Pisos y unidades",
			"units": "Unidades",
			"historial": "Historial"
		},
		"alerts": {
			"closeDialog": {
				"title": "Proceso cancelado",
				"subtitle": "has cancelado el proceso de agregar clientes a la unidad"
			},
			"unitAdded": {
				"title": "Unidad agregada",
				"subtitle": "Ahora las unidades que agregues podran visualizar en los clientes"
			},
			"unitNotAdded": {
				"title": "Unidad no agregada",
				"subtitle": "La unidad no ha sido agregado, porfavor verifique los campos"
			},
			"unitRemoved": {
				"title": "Unidad Eliminada",
				"subtitle": "Los usuarios ya no tendrán acceso a esta unidad"
			},
			"usersAddedToUnit": {
				"title": "Usuarios Agregados",
				"subtitle": "Los usuarios seleccionados ahora tienen acceso a esta unidad"
			},
			"error": {
				"title": "Falla con la plataforma",
				"subtitle": "Hubo un error con la plataforma, favor de comunicarse con vivipost"
			},
			"unitsWithError": {
				"title": "Algunas unidades no fueron agregadas",
				"subtitle": "Se detectaron unidades duplicadas. Por favor, verifica la información antes de continuar."
			}
		},
		"buttons": {
			"save": "Guardar",
			"add_units": "Agregar unidades",
			"add_unity": "Agregar unidad",
			"add_floor": "Agregar piso",
			"add_street": "Agregar calle",
			"export": "Exportar",
			"cancel": "Cancelar"
		},
		"cards": {
			"card-1": {
				"title": "Unidades totales",
				"tooltip": "Número total de unidades registradas desde el inicio del sistema.",
				"footer": "Información no disponible"
			},
			"card-2": {
				"title": "Promedio de usuarios por unidad",
				"tooltip": "Promedio de usuarios que recogen órdenes en cada unidad.",
				"footer": "Información no disponible"
			},
			"card-3": {
				"title": "Unidades activas",
				"tooltip": "Número total de unidades con usuarios activos.",
				"footer": "Información no disponible"
			},
			"card-4": {
				"title": "Unidades inactivas",
				"tooltip": "Unidades que no tienen usuarios registrados.",
				"footer": "Información no disponible"
			}
		},
		"overloads": {
			"noRows": {
				"title": "No hay nada aquí...",
				"subtitle": "Aqui podras visualizar las unidades"
			},
			"loading": {
				"title": "Cargando contenido..."
			}
		},
		"table": {
			"floor": "Piso",
			"unit": "Número\nde unidad",
			"address": "Dirección",
			"total_user_registered": "Total de usuarios\nregistrados",
			"total_user_active": "Total de usuarios\nactivos",
			"packages_delivered_to_the_unit_this_month": "Paquetes entregados a la unidad este mes",
			"packages_delivered_to_the_unit_all_time": "Paquetes entregados a la unidad en todo momento",
			"actions": "Acciones",
			"unit_code": "Código de unidad",
			"unit_type": "Tipo de unidad",
			"id_status": "Estatus",
			"register_date": "Fecha de registro",
			"update_date": "Fecha de actualización"
		},
		"dialog": {
			"dialogToEditUnit": {
				"title": "Actualizar unidad",
				"subtitle": "Aquí podrás actualizar la información de la unidad.",
				"buttons": {
					"cancel": "Cancelar",
					"update": "Actualizar unidad"
				}
			},
			"dialogToAddUnit": {
				"title": "Agregar Unidad",
				"subtitle": "Aqui podras agregar la unidad",
				"buttons": {
					"cancel": "Cancelar",
					"add": "Agregar unidad"
				}
			},
			"dialogToDeleteUnit": {
				"title": "Eliminar unidad",
				"subtitle": "Aquí podrás eliminar la información de la unidad.",
				"buttons": {
					"cancel": "Cancelar",
					"delete": "Eliminar unidad"
				}
			},
			"dialogToUpdateUnit": {
				"title": "Actualizar código de unidad",
				"subtitle": "Aquí podrás actualizar el código de la unidad.",
				"buttons": {
					"cancel": "Cancelar",
					"update": "Actualizar código de unidad"
				}
			}
		},
		"units": {
			"unit": "Unidad",
			"placeholder": {
				"unit_number": "Ingrese unidad",
				"apartment_number": "Coloca el número de departamento",
				"code": "123456",
				"guests_limit": "123456",
				"floor": "Coloca el número de piso",
				"street": "Coloca la calle del fraccionamiento"
			},
			"access_code": "Código de acceso",
			"maintenance_payment": "Pago por mantenimiento",
			"guests_limit": "Límite de invitados",
			"total_people": "Personas en la unidad",
			"usage_type": "Tipo de uso",
			"add_unit": "Agregar unidad",
			"save": "Guardar",
			"edit": "Editar",
			"delete": "Eliminar",
			"update_code": "Actualizar código",
			"show_residents": "Mostrar residentes",
			"floor": "Piso",
			"street": "Calle",
			"guests": "Invitados",
			"admins": "Administradores",
			"owners": "Dueños",
			"units": "Unidades",
			"yes": "Sí",
			"no": "No"
		},
		"residents": {
			"title": "Agregar residente a la unidad",
			"form": {
				"first_name": "Nombre",
				"last_name": "Apellido",
				"email": "Correo electrónico",
				"phone": "Teléfono",
				"description": "Descripción",
				"type_use": "Tipo de uso",
				"type_consumer": "Tipo de consumidor"
			},
			"placeholder": {
				"first_name": "Coloca el nombre",
				"last_name": "Coloca el apellido",
				"email": "Coloca el correo electrónico",
				"phone": "Coloca el teléfono",
				"description": "Coloca una descripción",
				"type_use": "Tipo de uso",
				"type_consumer": "Tipo de consumidor"
			},
			"buttons": {
				"save": "Guardar",
				"cancel": "Cancelar"
			}
		}
	},
	"unitDetailPage": {
		"title": "Detalle de la unidad",
		"breadcrumb": {
			"firstPage": "Unidades",
			"lastPage": "Unidad #"
		},
		"cards": {
			"card-1": {
				"title": "Código de acceso",
				"footer": "Código de acceso de la unidad",
				"tooltip": "Con este código se podrá acceder a las suscripciones de la unidad"
			},
			"card-2": {
				"title": "Límite de invitados",
				"footer": "invitados",
				"tooltip": "Este es el límite de invitados por unidad"
			},
			"card-3": {
				"title": "Piso",
				"footer": "de la unidad",
				"tooltip": "Número de piso donde se ubica la unidad"
			},
			"card-4": {
				"title": "Número de unidad",
				"footer": "",
				"tooltip": "Este es el número del apartamento"
			}
		},
		"table": {
			"client_name": "Nombre del cliente",
			"id_status": "Estatus",
			"type_consumer": "Tipo",
			"date_permanence": "Fecha de permanencia",
			"register_date": "Fecha de registro",
			"update_date": "Fecha de actualización",
			"actions": "Acciones"
		}
	},
	"subscriptionsPage": {
		"title": "Subscripciones",
		"contentSwitcher": {
			"resume_by_unity": "Resumen por unidad",
			"log_of_pays": "Historial de pagos",
			"last_pay": "Último pago"
		},
		"table": {
			"id_subscription": "ID",
			"folio": "Folio",
			"client_name": "Nombre\ndel cliente",
			"id_property": "ID Propiedad",
			"email": "Correo electrónico",
			"unit": "Unidad",
			"locker_name": "Locker",
			"unit_code": "Código\nde unidad",
			"id_status": "Estatus de pago",
			"total": "Total",
			"status": "Estatus",
			"register_date": "Fecha de registro",
			"cut_off_date": "Fecha de corte",
			"folio_number_expiration": "Expiración del pago",
			"update_date": "Fecha de actualización",
			"actions": "Acciones",
			"first_init_session": "Primer inicio de sesión",
			"gross_price_subscription": "Precio bruto\nde la subscripción",
			"tax_amount": "Monto\nde impuesto",
			"tax_percentage": "Porcentaje\nde impuesto",
			"net_price_subscription": "Precio neto\nde la subscripción",
			"payment_for_management": "Pago por\nadministración"
		},
		"paymentReport": {
			"paymentDate": "Fecha del pago:",
			"orderNumber": "Número de pedido:",
			"totalPayment": "Pago total:",
			"status": "Estatus",
			"confirmationDate": "Fecha de confirmación",
			"paying_user": "Usuario que pagó",
			"expirationDate": "Fecha de expiración del folio",
			"cutoffDate": "Fecha de corte",
			"receiptLink": "Enlace al recibo",
			"total": "Total:",
			"paidWith": "Pagado con Stripe",
			"showDetails": "Mostrar detalle",
			"unitsPaid": "Unidades pagadas",
			"billingDetails": "Detalles de facturación",
			"grossPrice": "Precio bruto",
			"taxAmount": "Importe de impuestos",
			"netPrice": "Precio neto",
			"relatedLinks": "Enlaces relacionados:",
			"printReceipt": "Imprimir recibo"
		},
		"report": {
			"payment_date": "Fecha de pago:",
			"folio_number": "Número de pedido",
			"total": "Pago total:",
			"status": "Estatus",
			"confirmation_date": "Fecha de confirmación",
			"folio_number_expiration": "Expiración del pago",
			"cut_off_date": "Fecha de corte",
			"link": "Recibo",
			"showDetail": "Ver detalle",
			"package_includes": {
				"title": "El paquete incluye"
			}
		},
		"subscriptionInformation": {
			"title": "Información de la subscripción",
			"propertyName": "Nombre de la propiedad:",
			"propertyCode": "Código de propiedad:",
			"cutoffDay": "Día de corte:",
			"cutoffDaySuffix": "de cada mes",
			"gracePeriod": "Período de gracia:",
			"requiresCarrierCode": "¿Requiere código de repartidor?",
			"requiresSignature": "¿Requiere firma?",
			"canExtendPayment": "¿Se puede extender el pago?",
			"currentUnits": "Unidades actuales que pagarán:",
			"yes": "Sí",
			"no": "No"
		},
		"paymentInformation": {
			"title": "Información del pago",
			"folioNumber": "Número de folio:",
			"cutoffDate": "Fecha de corte:",
			"amountToPay": "Monto a pagar:",
			"expirationDate": "Fecha de expiración:",
			"status": "Estatus:",
			"payButton": "Pagar",
			"payHistory": "Ver historial de pagos",
			"unitSummary": "Resumen de cargos por unidad"
		}
	},
	"companyInfo": {
		"title": "Información de la propiedad",
		"property": "Propiedad",
		"code": "Código",
		"urbanization_type": "Tipo de urbanización",
		"urbanization_description": "Descripción de la urbanización",
		"address": "Dirección",
		"description": "Descripción"
	},
	"unitInfo": {
		"title": "Información de la unidad",
		"unit": "Unidad",
		"usage_type": "Tipo de uso",
		"guest_limit": "Límite de invitados",
		"registration_date": "Fecha de registro",
		"access_code": "Código de acceso"
	},
	"residentsPage": {
		"breadcrumb": {
			"company": "Compañía",
			"residents": "Residentes",
			"properties": "Propiedades",
			"units": "Unidades"
		},
		"cards": {
			"card-1": {
				"title": "Total de clientes",
				"footer": "Total de clientes",
				"tooltip": "Cantidad total de clientes registrados"
			},
			"card-2": {
				"title": "Nuevos clientes registrados este mes",
				"footer": "Total de clientes",
				"tooltip": "Cantidad de nuevos clientes registrados este mes"
			},
			"card-3": {
				"title": "Clientes activos este mes",
				"footer": "Clientes activos este mes",
				"tooltip": "Cantidad de clientes activos este mes"
			},
			"card-4": {
				"title": "Clientes inactivos este mes",
				"footer": "Clientes inactivos este mes",
				"tooltip": "Cantidad de clientes inactivos este mes"
			}
		},
		"buttons": {
			"createUser": "Crear residente"
		},
		"table": {
			"first_name": "Nombre completo",
			"code": "Código",
			"consumer_type": "Rol",
			"main_tlf": "Teléfono",
			"sobriquet": "Alias",
			"initial_access": "Acceso inicial",
			"id_status": "Estatus",
			"description": "Descripción",
			"actions": "Acciones"
		}
	},
	"dialogToUploadUnit": {
		"title": "Importar unidades",
		"subtitle": "Revisa que los datos de las unidades que quieras ingresar sean correctos. Esto no es una acción definitiva; puedes editar los valores de las unidades manualmente dando doble clic sobre la unidad.",
		"table": {
			"name": "Nombre de la unidad",
			"code": "Código",
			"location": "Ubicación",
			"reference": "Referencia",
			"type": "Tipo de unidad",
			"isAccepted": "Estatus",
			"message": "Mensaje"
		},
		"buttons": {
			"addUnits": "Agregar unidades",
			"cancel": "Cancelar"
		},
		"error": {
			"title": "Hubo un error",
			"subtitle": "Los datos no han sido registrados. En breve verás un detalle del por qué no han sido ingresadas las unidades.",
			"buttons": {
				"close": "Cerrar"
			}
		}
	},
	"uploadUnits": {
		"buttonLabel": "Subir archivo de unidades",
		"popupTitle": "Importa tus datos de unidades",
		"popupSubtitle": "Puedes subir un archivo con los datos de tus unidades. Si aún no tienes un archivo con el formato correcto, puedes descargar una plantilla",
		"popupLink": "haciendo clic aquí.",
		"fileUploader": {
			"link": "Haz clic aquí",
			"clickHere": " para abrir el explorador de archivos y seleccionar el archivo a importar.",
			"fileSizeLimit": "El archivo que subas no puede ser mayor a 10 MB."
		},
		"fileUpload": {
			"fileName": "{{this.file.name}}",
			"fileSize": "{{ (this.file.size / 1024 / 1024).toFixed(2) }} MB",
			"progress": "{{this.progress}}%"
		},
		"errors": {
			"fileSizeOver": "Parece que el archivo que intentas subir pesa más de 10 MB. Revísalo e inténtalo de nuevo.",
			"invalidFileType": "El tipo de archivo no es válido. Sólo se permiten archivos Excel (extensión csv o xls).",
			"invalidHeaders": "El archivo no contiene los encabezados requeridos: Nombre, Apellido, Email, Teléfono."
		},
		"alert": {
			"text": "Usuarios creados",
			"subtitle": "Los usuarios han sido creados."
		}
	},
	"dialogToAssignUnit": {
		"title": "Asignar cliente a una unidad",
		"subtitle": "En este modal podrás asignar una unidad a un cliente que aún no tenga una.",
		"forms": {
			"unit": "Unidad",
			"client": "Cliente"
		},
		"placeholder": {
			"unit": "Seleccione una unidad",
			"client": "Seleccione al cliente"
		},
		"buttons": {
			"cancel": "Cancelar",
			"assign": "Asignar unidad"
		}
	},
	"initialAccess": {
		"active": "Activo",
		"inactive": "Inactivo"
	},
	"validatePackage": {
		"title": "Validar paquetes",
		"infoCard": {
			"title": "Validación de paquetes",
			"description": "Revisa la información del paquete comparando los datos de la etiqueta con los registrados en el sistema.",
			"subTitle": "¿Qué significa la calificación?",
			"subDescription": "Cada campo muestra un nivel de coincidencia que te ayuda a detectar errores en el tracking, destinatario, remitente, teléfono o dirección antes de procesar o entregar el paquete."
		},
		"form": {
			"title": "Metadata del paquete",
			"carrier": {
				"label": "Carrier",
				"placeholder": "Coloca al carrier de la etiqueta"
			},
			"tracking": {
				"label": "Tracking",
				"placeholder": "Coloca el tracking del paquete"
			},
			"recipient": {
				"label": "Recipiente",
				"placeholder": "Coloque al cliente de la etiqueta",
				"errorMessage": "Este campo es obligatorio"
			},
			"phone": {
				"label": "Teléfono",
				"placeholder": "Coloque el teléfono del cliente que está en la etiqueta"
			},
			"sender": {
				"label": "¿Quién lo envía?",
				"placeholder": "Coloque el correo del cliente que está en la etiqueta"
			},
			"address": {
				"label": "Dirección",
				"placeholder": "Coloque la dirección del cliente que está en la etiqueta"
			},
			"score": {
				"label": "Calificación",
				"total": "Calificación total"
			}
		},
		"controls": {
			"rotate": "Rotar imagen",
			"download": "Descargar imagen",
			"expand": "Ver en pantalla completa",
			"prev": "Imagen anterior",
			"next": "Imagen siguiente"
		},
		"footer": {
			"cancel": "Cancelar",
			"validate": "Validar paquete"
		}
	},

	"ticketsPage": {
		"title": "Tickets",
		"contentSwitcher": {
			"new": "Nuevo",
			"process": "En proceso",
			"solved": "Resuelto",
			"archived": "Archivado"
		},
		"cards": {
			"new": {
				"title": "Tickets nuevos",
				"tooltip": "Tickets que han sido creados por clientes",
				"footer":"Footer ticket"
			},
			"process": {
				"title": "Tickets en proceso",
				"tooltip": "Tickets que ya han iniciado una conversación o han sido leídos",
				"footer":"Footer ticket"
			},
			"solved": {
				"title": "Tickets cerrados",
				"tooltip": "Tickets que ya han sido resueltos por soporte",
				"footer":"Footer ticket"
			},
			"total": {
				"title": "Tickets totales",
				"tooltip": "Total de tickets que se han generado",
				"footer":"Footer ticket"
			}
		},
		"table": {
			"common": {
				"status": "Estado",
				"subject": "Asunto",
				"property": "Nombre de\nla propiedad",
				"unit": "Unidad",
				"id_ticket": "ID del ticket",
				"time_request": "Tiempo de solicitud",
				"last_update": "Última actualización",
				"registration_date": "Fecha\nde registro",
				"client": "Cliente",
				"support_name": "Usuario\nde soporte",
				"actions": "Acciones"
			},
			"new": {
				"empty": "No hay tickets nuevos disponibles"
			},
			"process": {
				"empty": "No hay tickets en proceso disponibles"
			},
			"solved": {
				"empty": "No hay tickets resueltos disponibles"
			},
			"archived": {
				"empty": "No hay tickets archivados disponibles"
			}
		},
		"alerts": {
			"deleted": {
				"title": "Ticket eliminado",
				"subtitle": "El ticket ha sido eliminado con éxito"
			},
			"archived": {
				"title": "Ticket archivado",
				"subtitle": "El ticket ha sido archivado con éxito"
			},
			"changed": {
				"title": "Asunto cambiado",
				"subtitle": "El asunto del ticket ha sido cambiado con éxito"
			},
			"error": {
				"title": "Ocurrió un error",
				"subtitle": "No se pudo completar la operación, inténtalo nuevamente"
			}
		},
		"buttons": {
			"export": "Exportar",
			"filter": "Filtrar",
			"clear": "Limpiar",
			"close": "Cerrar",
			"accept": "Aceptar",
			"cancel": "Cancelar"
		},
		"filters": {
			"search_placeholder": "Buscar por ID, asunto o cliente",
			"date_from": "Desde",
			"date_to": "Hasta",
			"status": "Filtrar por estado"
		},
		"overlay": {
			"loading": "Cargando contenido...",
			"noRows": {
				"new": {
					"title": "No hay tickets nuevos",
					"subtitle": "Aquí se mostrarán los tickets que los clientes acaban de crear"
				},
				"process": {
					"title": "No hay tickets en proceso",
					"subtitle": "Aquí verás los tickets que están siendo revisados"
				},
				"solved": {
					"title": "No hay tickets resueltos",
					"subtitle": "Aquí se mostrarán los tickets ya solucionados"
				},
				"archived": {
					"title": "No hay tickets archivados",
					"subtitle": "Aquí se mostrarán los tickets que han sido archivados"
				}
			}
		}
	},
	"ticketsDetailPage":{
		"breadcrumb": {
			"tickets": "Ticket",
			"current": "Detalle"
		},
		"title": "Detalle del ticket",
		"conversationWithClient":{
			"starter":"Conversacion con",
			"chips":{
				"update":"Actualizar"
			},
			"status":{
				"new":"Nuevo",
				"solved":"Resuelto",
				"archived":"Archivado",
				"deleted":"Eliminado",
				"inProgress":"En proceso"
			},
			"popUpContainer":{
				"closeTicket":"Cerrar ticket",
				"deleteTicket":"Eliminar ticket",
				"reasignTicket":"Reasignar ticket",
				"changeSubject":"Cambiar asunto",
				"archivedTicket":"Archivar ticket"
			},
			"sentText":{
				"placeholder":{
					"text":"Escribe un mensaje",
					"note":"Escribe una nota interna"
				}
			},
			"buttons":{
				"sendText":"Enviar",
				"sendNote":"Enviar nota interna"
			},
			"alerts":{
				"unauthorized":{
					"title":"No puedes hacer cambios",
					"subtitle":"El ticket ha sido asignado a otro usuario de soporte"
				},
				"unabledToChat":{
					"title":"No se puede mandar mensajes",
					"subtitle":"No tienes permisos para mandar mensajes a este ticket"
				},
				"unabledToDelete":{
					"title":"No se logro eliminar el ticket",
					"subtitle":"No tienes permisos para eliminar este ticket"
				},
				"unabledToArchived":{
					"title":"No se logro archivar el ticket",
					"subtitle":"No tienes permisos para archivar este ticket"
				},
				"subjectNotChanged":{
					"title":"Asunto de ticket no cambiado",
					"subtitle":"El asunto del ticker no ha sido cambiado porque no tienes permisos"
				},
				"subjectChanged":{
					"title":"Asunto de ticket cambiado",
					"subtitle":"El asunto del ticker ha sido cambiado con exito"
				},
				"notAssigned":{
					"title":"No se ha asignado el usuario al ticket",
					"subtitle":"El ticket ya ha sido asignado una vez a un usuario, no se puede volver a asignar"
				},
				"closed":{
					"title":"Ticket Cerrado",
					"subtitle":"El ticket ha sido eliminado, el ticket dejara de aparecer en la lista y te redirigiremos a la pagina de tickets"
				},
				"deleted":{
					"title":"Ticket eliminado",
					"subtitle":"El ticket ha sido eliminado, el ticket dejara de aparecer en la lista y te redirigiremos a la pagina de tickets"
				},
				"assigned":{
					"title":"Se ha asignado el usuario al ticket",
					"subtitle":"El ticket ya ha sido asignado al nuevo usuario, no se podra volver a asignar"
				},
				"isArchived":{
					"title":"Se ha archivado el ticket",
					"subtitle":"El ticket ya ha sido archivado, no se podra volver a modificar"
				}
			}
		},
		"propertyInformation":{
			"title":"Informacion de la propiedad",
			"field":{
				"property":"Nombre de la propiedad",
				"phone":"Telefono",
				"week":"Horario Lunes a Viernes",
				"weekend":"Horario Fin de semana",
				"address":"Direccion"
			}
		}
	},
	"camerasPage": {
		"title": "Cámaras",
		"subtitle": "Selecciona una cámara para solicitar una grabación",
		"view": {
			"empty": "Tu grabación se verá aquí"
		},
		"table": {
			"cam_name": "Nombre\nde cámara",
			"type": "Tipo",
			"format": "Formato",
			"function": "Función",
			"fps": "FPS",
			"status": "Estado"
		},
		"request": {
			"title": "Solicita una grabación de",
			"note": "Nota: este proceso puede tardar unos minutos"
		},
		"calendar": {
			"title": "Selecciona una fecha"
		},
		"time": {
			"start": "Selecciona una hora de inicio",
			"end": "Selecciona una hora de finalización"
		},
		"buttons": {
			"clear": "Borrar",
			"cancel": "Cancelar",
			"search": "Buscar grabación"
		},
		"records": {
			"title": "Grabaciones disponibles",
			"table": {
				"id_record": "Evento",
				"date_record": "Fecha",
				"duration": "Duración",
				"size": "Tamaño",
				"actions": "Acciones"
			}
		},
		"overloads": {
			"noRows": {
				"title": "No hay nada por aquí...",
				"subtitle": "No se encontraron grabaciones para el rango seleccionado."
			},
			"loading": {
				"title": "Cargando grabaciones..."
			}
		},
		"alerts": {
			"searchSuccess": {
				"title": "Grabaciones encontradas",
				"subtitle": "Las grabaciones se cargaron correctamente."
			},
			"searchEmpty": {
				"title": "Sin resultados",
				"subtitle": "No se encontraron grabaciones en el rango seleccionado."
			},
			"searchError": {
				"title": "Error al buscar grabaciones",
				"subtitle": "Ocurrió un error. Intenta nuevamente."
			}
		}
	},
	"camerasDetail":{
		"title":"Eventos del paquete: ",
		"recordWillDisplayed":{
			"title":"Tu grabación se verá aquí"
		},
		"recordError":{
			"title":"No se pudo reproducir el video",
			"subtitle":"La grabación no está disponible o ocurrió un problema al cargarla.",
			"button":"Reintentar"
		},

		"timePicker":{
			"startTime":"Hora de inicio",
			"endTime":"Hora Final"
		}

	}
}
